import app, { Component } from 'apprun';
import { auth, users as userApi } from './api';

import SearchAdv from './search-adv';

const inactiveStyle = { 'background-color':'#F9CED4' };
const Item = ({ item, showInactive }) => (
  (showInactive || item.status==='A')
    ?
    <tr class="hand" $onclick={['#user', item.personID, item.name]} style={item.status==='A'?{}:inactiveStyle}>
      <td>
        <a>{item.permissionLvl === 'Agent / Sales Representative' ? 'Agent' : item.permissionLvl}</a>
      </td>
      <td>
        <a>{item.name}</a>
      </td>
      <td>
        <a>{item.cityProv}</a>
      </td>
    </tr>
    :''
);

const List = ({ items, showInactive }) => (
  <table class="table table-striped table-condensed table-bordered table-hover">
    <thead>
      <tr>
        <th>Title</th>
        <th>Name</th>
        <th>city</th>
      </tr>
    </thead>
    <tbody>
      {items.map(item => (
        <Item item={item} showInactive={showInactive} />
      ))}
    </tbody>
  </table>
);

export default class CompanyUsresComponent extends Component {
  state = {
    users: [],
    usersRead: [],
    filter: '',
    loadFilter: '',
    accessMap: null,
    createAllowed: null,
    showInactive: true,
  }

  view = (state) => {
    if (!state || !state.users) {return;}
    return (
      <div style={{ width: '650px' }}>
        <div class="input-group">
          <input class="form-control" placeholder="Search..." oninput={e => this.run('search', e)} value={state.filter || ''} />
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" onclick={() => this.run('show-AdvSearch')}> Advanced </button>
            <button class="btn btn-default" type="button" onclick={() => this.run('#user-new')} disabled={!state.createAllowed} > + </button>
          </span>
        </div>
        <div>
          <input class="text-left" type="checkbox" onchange={e => this.run('toggleshowInactive', e)} checked={state.showInactive ? 'checked' : null} /> show inactive
        </div>
        <List items={state.users} showInactive={state.showInactive}/>
        <button type="button" style={{ 'width': '100%', 'display':(this.isMore(state))?'block':'none' }} onclick={() => this.run('load-more')}>Load ommitted</button>
      </div>
    );
  };

  update = {
    refresh: async (state, companyId, locationId) => {
      if (state.users.length && state.companyId === companyId && state.locationId === locationId) { return state; }
      const createAllowed = await auth.hasPermission('UserCreate', 'C');
      const usersRead = (await userApi.getUsersList(companyId, locationId)) || [];
      state.loadFilter = state.filter;
      state.advMode = false;
      return { ...state, users: usersRead, usersRead, companyId, locationId, createAllowed };
    },

    toggleshowInactive: (state, e) => ({ ...state, showInactive: e.target.checked }),

    'load-more': async (state) => {
      state.loadFilter = state.filter;
      state.users = state.usersRead =
        (await userApi.getUsersList(state.companyId, state.locationId, state.filter)) || [];
      state.advMode = false;
      return state;
    },

    //search: (state, e) => ({ ...state, filter: e.target.value })
    search: (state, e) => {
      state.filter = e.target.value;
      state.users = state.usersRead.filter(u => u.name.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0);
      return state;
    },

    'show-AdvSearch': (state) => {
      app.run('#add-panel', {
        id: 'AdvSearch',
        title: 'Advanced Search',
        Component: SearchAdv,
        level: 2,
        state: { companyId: state.companyId, locationId: state.locationId, caller: this }
      });
    },

    '#get-AdvSearch-results': async (state, criteria) => {
      state.users = state.usersRead = (await userApi.searchAdvance(criteria)) || [];
      state.advMode = true;
      state.filter = '';
      return state;
    },

  };

  isFilterNarrowed = (state): boolean => {
    if (state.filter.indexOf(state.loadFilter) > -1) {
      return state.loadFilter.length < state.filter.length;
    }
    return false;
  };

  isFilterExpanded = (state): boolean => {
    if (state.loadFilter.indexOf(state.filter) > -1) {
      return state.loadFilter.length > state.filter.length;
    }
    return false;
  };

  isMore = (state): boolean => {
    if (state.advMode || state.loadFilter === state.filter || state.users.length >= 1000) {return false;}
    if (this.isFilterNarrowed(state)) {
      return state.usersRead.length >= 1000;
    } else if (this.isFilterExpanded(state)) {
      return state.usersRead.length < 1000;
    } else {
      return true;
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state.companyId, state.locationId);
  };
}
